import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import libraryStore from "../../../services/stores/library.store";
import { GraphicsInfo } from "../../../domain/graphics-info";

@Component({
  selector: "icn-edit-graphics-aside",
  templateUrl: "./edit-graphics-aside.component.html",
  styleUrls: ["./edit-graphics-aside.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditGraphicsAsideComponent {
  @Input()
  graphicsInfo: GraphicsInfo;

  @Output()
  private save = new EventEmitter();

  @Output()
  goLive = new EventEmitter();

  /* Assign the store */
  libraryStore = libraryStore;

  saving = false;

  constructor() {}

  /**
   * Changing mam
   * @return void
   */
  ngOnInit() {
    /* Requesting to change mam (in case of straight load) */
    //libraryStore.setLibraryType(libraryStore['LIBRARY_TYPE']['GRAPHICS']);
  }

  /**
   * On Saving Callback
   * @return void
   */
  onSave() {
    return (event) => {
      this.saving = true;
      this.save.emit();
      this.saving = false;
    };
  }
}
